import refundIcon from '../assets/refund.png'
import PackModel from '../models/pack.model'

const PricingCard = (props: { pack: PackModel; onClick: () => void }) => {
    // Determina se è il piano più popolare (quello di mezzo o con più BC)
    const isPopular = props.pack.name.toLowerCase().includes('promo') || props.pack.betcoins === 100
    
    // Determina la posizione della card (prima, seconda, terza)
    const getCardPosition = () => {
        // Assumiamo ordine: Start (30 BC), Promo (100 BC), Campione (300 BC)
        if (props.pack.betcoins === 30) return 'first'
        if (props.pack.betcoins === 100) return 'second' 
        if (props.pack.betcoins === 300) return 'third'
        // Fallback per altri valori
        if (props.pack.price <= 30) return 'first'
        if (props.pack.price <= 50) return 'second'
        return 'third'
    }
    
    const cardPosition = getCardPosition()
    
    // Calcola il valore per BC
    const valuePerBC = (props.pack.price / props.pack.betcoins).toFixed(2)
    
    // Componente tooltip FUORI dalla card per evitare overflow
    const TooltipInfo = ({ text }: { text: string }) => (
        <div className="relative group inline-block static">
            <div className="w-5 h-5 bg-gradient-to-br from-blue-400 to-blue-600 text-white rounded-full flex items-center justify-center text-xs cursor-help font-bold shadow-sm border border-blue-300">
                i
            </div>
            <div className="fixed top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 px-4 py-3 bg-gradient-to-r from-blue-500 to-blue-600 text-white text-sm rounded-lg opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none z-[999999] shadow-2xl border border-blue-300 max-w-xs text-center">
                {text}
            </div>
        </div>
    )
    
    return (
        <div className={`
            relative bg-gradient-to-br from-gray-800 to-gray-900 
            rounded-2xl border-2 transition-all duration-300 hover:scale-105 
            shadow-lg hover:shadow-2xl mx-auto
            p-4 sm:p-6 max-w-xs sm:max-w-sm 
            ${isPopular 
                ? 'border-primary bg-gradient-to-br from-primary/10 to-gray-900 shadow-primary/20' 
                : 'border-gray-700 hover:border-gray-600'
            }
        `}>
            {/* Badge "Più Popolare" */}
            {isPopular && (
                <div className="absolute -top-3 left-1/2 transform -translate-x-1/2">
                    <div className="bg-gradient-to-r from-primary to-green-400 text-white px-3 py-1 rounded-full text-xs font-bold shadow-lg scale-75 whitespace-nowrap">
                        🔥 PIÙ POPOLARE
                    </div>
                </div>
            )}
            
            {/* Header */}
            <div className="text-center mb-4">
                <h3 className="text-xl font-bold text-white mb-2">
                    {props.pack.name}
                </h3>
                <div className="flex items-baseline justify-center gap-1">
                    {/* MODIFICA: Ridotta dimensione font del prezzo */}
                    <span className="text-3xl font-bold text-white">
                        {props.pack.price}
                    </span>
                    <span className="text-gray-400 text-lg">€</span>
                </div>
                <p className="text-gray-400 text-sm mt-1">
                    {valuePerBC}€ per BC
                </p>
            </div>
            
            {/* Betcoins Highlight */}
            <div className={`
                text-center py-4 rounded-xl mb-4
                ${isPopular 
                    ? 'bg-gradient-to-r from-yellow-400/20 to-primary/20 border border-yellow-400/30' 
                    : 'bg-gray-700/50 border border-gray-600'
                }
            `}>
                {/* MODIFICA: Ridotta dimensione font dei Betcoins */}
                <div className="text-2xl font-bold text-yellow-400 mb-1">
                    {props.pack.betcoins}
                </div>
                <div className="text-yellow-400 font-semibold text-sm">
                    BETCOINS
                </div>
            </div>
            
            {/* Features List */}
            <div className="space-y-3 mb-4">
                <div className="flex items-center gap-3">
                    <div className="w-5 h-5 bg-green-500 rounded-full flex items-center justify-center flex-shrink-0">
                        <svg className="w-3 h-3 text-white" fill="currentColor" viewBox="0 0 20 20">
                            <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd"/>
                        </svg>
                    </div>
                    <span className="text-gray-300 text-sm">Accesso completo ai pronostici</span>
                </div>
                
                <div className="flex items-center gap-3">
                    <div className="w-5 h-5 bg-green-500 rounded-full flex items-center justify-center flex-shrink-0">
                        <svg className="w-3 h-3 text-white" fill="currentColor" viewBox="0 0 20 20">
                            <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd"/>
                        </svg>
                    </div>
                    <span className="text-gray-300 text-sm">Supporto clienti 24/7</span>
                </div>
                
                {/* Features aggiuntive basate sulla posizione */}
                {cardPosition === 'second' && (
                    <div className="flex items-center gap-3">
                        <div className="w-5 h-5 bg-green-500 rounded-full flex items-center justify-center flex-shrink-0">
                            <svg className="w-3 h-3 text-white" fill="currentColor" viewBox="0 0 20 20">
                                <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd"/>
                            </svg>
                        </div>
                        <span className="text-gray-300 text-sm">+50 Crediti LiveSuperBot</span>
                        <TooltipInfo text="Per avere i Crediti del LiveSuperBot clicca su Assistenza Rapida in alto e scrivici" />
                    </div>
                )}
                
                {cardPosition === 'third' && (
                    <>
                        <div className="flex items-center gap-3">
                            <div className="w-5 h-5 bg-green-500 rounded-full flex items-center justify-center flex-shrink-0">
                                <svg className="w-3 h-3 text-white" fill="currentColor" viewBox="0 0 20 20">
                                    <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd"/>
                                </svg>
                            </div>
                            <span className="text-gray-300 text-sm">+100 Crediti LiveSuperBot</span>
                            <TooltipInfo text="Per avere i Crediti del LiveSuperBot clicca su Assistenza Rapida in alto e scrivici" />
                        </div>
                        <div className="flex items-center gap-3">
                            <div className="w-5 h-5 bg-green-500 rounded-full flex items-center justify-center flex-shrink-0">
                                <svg className="w-3 h-3 text-white" fill="currentColor" viewBox="0 0 20 20">
                                    <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd"/>
                                </svg>
                            </div>
                            <span className="text-gray-300 text-sm">Diventa Tipster e guadagna!</span>
                            <TooltipInfo text="Clicca su Assistenza Rapida in alto e scrivici per sapere come!" />
                        </div>
                    </>
                )}
            </div>
            
            {/* Garanzia rimborso */}
            <div className="bg-gradient-to-r from-green-600/20 to-green-500/20 border border-green-500/30 rounded-lg p-3 mb-4">
                <div className="flex items-center gap-2">
                    <img src={refundIcon} alt="Garanzia" className="w-5 h-5" />
                    <span className="text-green-400 text-xs font-medium">
                        Rimborso garantito sui crediti lose
                    </span>
                    <TooltipInfo text="Rimborso crediti lose: 50% subito + 50% al secondo acquisto" />
                </div>
            </div>
            
            {/* CTA Button */}
            <button
                onClick={props.onClick}
                className="w-full py-3 px-6 rounded-xl font-bold text-lg transition-all duration-300 transform hover:scale-105 active:scale-95 shadow-lg bg-gradient-to-r from-yellow-400 to-yellow-500 text-gray-900 hover:from-yellow-300 hover:to-yellow-400 shadow-yellow-400/30"
            >
                ATTIVA OFFERTA
            </button>
            
            {/* Footer note */}
            <p className="text-gray-500 text-xs text-center mt-3">
                Attivazione immediata
            </p>
        </div>
    )
}

export default PricingCard